var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgCopy = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8006 9.05389L12.4006 9.2526C11.6006 9.35196 10.9006 8.85518 10.9006 8.06033L10.6006 5.67578H10.7006L14.8006 9.05389Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 17.7972C15.7002 18.5921 15.1002 19.2876 14.4002 19.2876L7.00016 19.9831H6.90016H6.70016C5.90016 20.0824 5.20016 19.4863 5.20016 18.7908L4.00016 7.76226C3.90016 6.96741 4.50016 6.27192 5.30016 6.17256L10.6002 5.67578H10.7002L10.9002 7.96097C10.9002 8.15968 11.0002 8.35839 11.1002 8.45775C11.2002 8.55711 11.3002 8.75582 11.4002 8.85517C11.6002 9.15324 12.0002 9.35195 12.4002 9.2526H12.6002H12.7002L14.7002 9.05389L15.6002 17.7972Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 9.05389L14.9998 9.15324H14.8998L12.9998 9.2526C12.8998 9.2526 12.7998 9.2526 12.7998 9.2526C12.0998 9.2526 11.5998 8.65646 11.4998 8.06033L11.2998 6.17256V6.07321V5.67578H11.3998L15.3998 9.05389Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5998 17.7972C15.6998 18.5921 15.0998 19.2876 14.3998 19.2876L6.99981 19.9831C6.39981 19.8837 5.79981 19.3869 5.79981 18.7908L4.59981 7.76226C4.49981 6.96741 5.09981 6.27192 5.79981 6.17256L10.5998 5.67578H10.6998H10.9998H11.0998V6.07321V6.17256L11.2998 7.96097C11.3998 8.65646 11.8998 9.15324 12.5998 9.15324C12.6998 9.15324 12.7998 9.15324 12.7998 9.15324L14.5998 8.95453L15.5998 17.7972Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 7.95912H17.6002C16.8002 7.95912 16.2002 7.36299 16.2002 6.56814V4.18359L16.3002 4.28295L20.0002 7.95912Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 7.95912V16.7025C20.0004 17.4973 19.4004 18.0934 18.6004 18.0934H10.8004C10.0004 18.0934 9.40039 17.4973 9.40039 16.7025V5.57458C9.40039 4.77973 10.0004 4.18359 10.8004 4.18359H16.1004H16.2004V6.56814C16.2004 7.36299 16.8004 7.95912 17.6004 7.95912H20.0004Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 7.95912V16.7025C19.9996 17.4973 19.3996 18.0934 18.5996 18.0934H11.4996C10.6996 18.0934 10.0996 17.4973 10.0996 16.7025V5.57458C10.0996 4.77973 10.6996 4.18359 11.4996 4.18359H16.1996H16.2996V6.56814C16.2996 7.36299 16.8996 7.95912 17.6996 7.95912H19.9996Z",
    fill: "url(#paint6_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.6572,
    y1: 9.32448,
    x2: 12.4601,
    y2: 7.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10.5042,
    y1: 3.14061,
    x2: 9.10536,
    y2: 23.0277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.2147,
    y1: 4.65321,
    x2: 7.6912,
    y2: 15.3811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 15.6473,
    y1: 4.95665,
    x2: 8.12387,
    y2: 15.6846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 19.2274,
    y1: 4.25604,
    x2: 17.385,
    y2: 7.26929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9342,
    stopColor: "#3C6CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 18.6946,
    y1: 5.03716,
    x2: 10.928,
    y2: 17.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 12.3097,
    y1: -1.76008,
    x2: 16.1259,
    y2: 18.2304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.897,
    fill: "white",
    transform: "translate(4 4.18359)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Copy.6bb3c6a9.svg";
export { ForwardRef as ReactComponent };